import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from "../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import {first} from "rxjs/operators";
import {VoucherTemplate} from "../models/voucherTemplate";
import {VoucherTemplateService} from "../services/voucherTemplate.service";
import { locale as polish } from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {MatDialog} from "@angular/material/dialog";
import {MarketingAction} from "../models/marketingAction";
import {DeleteMarketingActionDialogComponent} from "../marketingAction/dialog/deleteMarketingActionDialog.component";
import {FormGroup} from "@angular/forms";
import {DeleteVoucherTemplateDialogComponent} from "./dialog/deleteVoucherTemplateDialog.component";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {ComponentTitleService} from "../services/componentTitle.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    templateUrl: './voucherTemplateSorting.component.html',
    styleUrls: ['./voucherTemplateSorting.component.scss']
})
export class VoucherTemplateSortingComponent implements OnDestroy, OnInit {
    rows: VoucherTemplate[];
    loadingIndicator: boolean;
    reorderable: boolean;
    selected = [];
    deleteDialogRef: any;
    loading: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private alertService: AlertService,
        private _fuseSidebarService: FuseSidebarService,
        private voucherTemplateService: VoucherTemplateService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private _matSnackBar: MatSnackBar,
        public _matDialog: MatDialog,
    ) {
        this.translationLoader.loadTranslations(polish);

        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        componentTitleService.addPart('Voucher templates');
        componentTitleService.addPart('Sorting for POS');
    }

    ngOnInit() {
        this.voucherTemplateService.getAllForPos().pipe(first())
            .subscribe( (res: VoucherTemplate[]) => {
                    this.rows = res;
                    this.loadingIndicator = false;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    drop(event: CdkDragDrop<string[]>) {
        this.loading = true;
        moveItemInArray(this.rows, event.previousIndex, event.currentIndex);
        let order = [];

        for (let i = 0; i < this.rows.length; i++) {
            order.push({
                "id": this.rows[i].id,
                "order": i
            })
        }

        this.voucherTemplateService.updateOrder({"order": order})
            .pipe(first())
            .subscribe(
                data => {
                    this.loading = false;
                    this._matSnackBar.open('Update successful', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Voucher template update error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }
}
